import { MentionableUser } from '../../types';
import { callExternalApi, CallResult } from '../callExternalApi';

export const fetchMentionableUpstackers = async (): Promise<CallResult<MentionableUser[]>> => {
  return await callExternalApi<MentionableUser[]>({
    url: 'api/user/mentionable-upstackers',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
